/**
 * Lead Time Distribution Chart (Highcharts)
 * Column chart showing booking window distribution
 */
import { useMemo } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

export default function LeadTimeDistributionChart({ data = [] }) {
  const options = useMemo(() => {
    if (!data || data.length === 0) {
      return {
        title: { text: 'Booking Lead Time Distribution' },
        subtitle: { text: 'No data available for this period/channel' },
        series: [],
      };
    }

    const buckets = ['0-2', '3-7', '8-14', '15-30', '31-60', '61-90', '91+'];
    const values = buckets.map(bucket => {
      const item = data.find(d => d.lead_time_bucket === bucket);
      return item ? item.reservation_count : 0;
    });

    return {
      chart: {
        type: 'column',
        height: 350,
      },
      title: {
        text: 'Booking Lead Time Distribution',
        style: { fontSize: '16px', fontWeight: '600' },
      },
      subtitle: {
        text: "This chart shows how far in advance guests booked their stay. For example, '15–30 days' means the reservation was made between 15 and 30 days before check-in.",
        style: { fontSize: '12px', color: '#666' },
      },
      xAxis: {
        categories: buckets,
        title: { text: 'Days Before Check-in' },
      },
      yAxis: {
        title: { text: 'Number of Reservations' },
        min: 0,
      },
      tooltip: {
        backgroundColor: '#ffffff',
        borderColor: '#e5e7eb',
        borderWidth: 1,
        style: { color: '#111827' },
        formatter: function() {
          // Use this.point.category to get the bucket label string (e.g. "31-60")
          // this.x is the numeric index, not the category string
          const bucket = this.point.category || this.point.name || String(this.x);
          return '<b>' + bucket + ' days before check-in</b><br/>' +
            'Reservations: <b>' + this.y + '</b>';
        },
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
            formatter: function() {
              // Only show labels for values > 0 to avoid clutter
              if (this.y > 0) {
                return this.y;
              }
              return '';
            },
            style: {
              fontSize: '11px',
              fontWeight: '500',
              textOutline: '1px contrast',
            },
          },
        },
      },
      series: [{
        name: 'Reservations',
        data: values,
        color: '#FF6B6B',
      }],
      credits: { enabled: false },
    };
  }, [data]);

  return <HighchartsReact highcharts={Highcharts} options={options} />;
}
